export const DivCell = ({children, className}) => {
    return (
        <div className={`${className} mr-1 px-1`}>
            {children}
        </div>
    );
}